import { useEffect, useMemo } from "react";
import { apiService } from "../api";
import { useAppSelector } from "../store/hooks";

async function sendAnalytics(data: any) {
  await apiService.saveUserAnalyticsData(data);
}

export const useUserAnalytics = () => {
  const location = useMemo(
    () => ({
      pathname: window.location.pathname,
      search: window.location.search,
      domain: window.location.hostname
    }),
    []
  );
  const userId = useAppSelector(state => state.user.userId);

  // Track page enter and leave on every route change
  useEffect(() => {
    const pageUrl = window.location.href;
    const enterTimestamp = Date.now();

    // Send page enter event
    sendAnalytics({
      event: "page_enter",
      pageUrl,
      enterTimestamp,
      referrer: document.referrer,
      visitorId: userId,
      domain: location.domain
    });

    // Cleanup: send page leave event when route changes or component unmounts
    return () => {
      const leaveTimestamp = Date.now();
      sendAnalytics({
        event: "page_leave",
        pageUrl,
        enterTimestamp,
        leaveTimestamp,
        visitorId: userId,
        domain: location.domain
      });
    };
  }, [location.domain, location.pathname, location.search, userId]);

  // Set up click event handler once
  useEffect(() => {
    // Click event handler
    const handleClick = (e: MouseEvent) => {
      const target = (e.target as HTMLElement).closest("[data-trackable]");

      if (target) {
        const trackableId = target.getAttribute("data-trackable");
        const timestamp = Date.now();
        const pageUrl = window.location.href;

        sendAnalytics({
          event: "cta_click",
          trigger: trackableId,
          timestamp,
          pageUrl,
          visitorId: userId,
          domain: location.domain
        });
      }
    };

    document.addEventListener("click", handleClick, true); // Use capture phase

    return () => {
      document.removeEventListener("click", handleClick, true);
    };
  }, [location, userId]);
};
